import Vue from 'vue';
import accountManagement from '@/page/accountManagement/config/api.js';
export { accountManagement };
export const baseUrl = '/rest/gongye/saas';
export const login = {
  login(data) {
    return Vue.http.post(`${baseUrl}/user/login`, data);
  },
  sendMessageCode(data) {
    return Vue.http.post(`${baseUrl}/user/sendMessageCode`, data);
  },
  getUserDataByToken(data) {
    return Vue.http.post(`${baseUrl}/user/getUserDataByToken`, data);
  },
  passwordLogin(data) {
    return Vue.http.post(`${baseUrl}/user/passwordLogin`, data);
  },
  validatePhoneAndSmscodeForResetPassword(data) {
    return Vue.http.post(
      `${baseUrl}/user/validatePhoneAndSmscodeForResetPassword`,
      data
    );
  },
  resetUserPwd(data) {
    return Vue.http.post(`${baseUrl}/user/resetUserPwd`, data);
  },
  //设置密码
  setUserPwd(data) {
    return Vue.http.post(`${baseUrl}/user/setUserPwd`, data);
  },
  verifyImgCode: `${baseUrl}/user/verifyImgCode`,
  getVerification(data) {
    return Vue.http.post(
      `${baseUrl}/get/verification/imageJson?type=slide`,
      data
    );
  }
};

export const csoPayOrder = {
  // 检查是否需要展示tab栏
  check(data) {
    return Vue.http.get(`${baseUrl}/csoPayOrder/check`, data);
  }
};
export const receive = {
  listStatement(data) {
    return Vue.http.post(`${baseUrl}/receive/listStatement`, data);
  },
  receiveTaskRecord(data) {
    return Vue.http.post(`${baseUrl}/receive/receiveTaskRecord`, data);
  },
  signStatement(data) {
    return Vue.http.post(`${baseUrl}/receive/signStatement`, data);
  }
};

// export const login = (data) => Vue.http.post(`${baseUrl}/login/auth`, data)
export const dicArea = {
  queryProvince(data) {
    return Vue.http.post(`/rest/ysh/oss/base/area`, data);
  }, //获取用户 menuList
  queryCity(data) {
    return Vue.http.post(`/rest/ysh/oss/base/area`, data);
  }, //获取用户 menuList
  queryArea(data) {
    return Vue.http.post(`/rest/ysh/oss/base/area`, data);
  } //获取用户 menuList
};
export const dicQueryList = data => {
  return Vue.http.post(`/rest/dic/queryList`, data);
}; //字典列表
export const user = {
  //个人中心
  userCenter(data) {
    return Vue.http.post(`${baseUrl}/user/userCenter`);
  },
  updateEnterprise(data) {
    return Vue.http.post(`${baseUrl}/user/updateEnterprise`, data);
  }
};
export const academy = {
  // 学术拜访
  xueshuProjectList(data) {
    // 列表
    return Vue.http.post(`${baseUrl}/project/xueshuProjectList`, data);
  },
  addUpdateXueshuProject(data) {
    // 新增/修改
    return Vue.http.post(`${baseUrl}/project/addUpdateXueshuProject`, data);
  },
  loadXueshuProject(data) {
    // 详情
    return Vue.http.post(`${baseUrl}/project/loadXueshuProject`, data);
  },
  deleteXueshuProject(data) {
    return Vue.http.post(`${baseUrl}/project/deleteXueshuProject`, data);
  },
  taskDetail(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/selectXsbfTaskDetail`,
      data
    );
  },
  xueshuCustomerList(data) {
    // 详情
    return Vue.http.post(`${baseUrl}/project/xueshuCustomerList`, data);
  }
};
export const otc = {
  // otc
  otcProjectList(data) {
    return Vue.http.post(`${baseUrl}/project/otcProjectList`, data);
  },
  addUpdateOtcProject(data) {
    return Vue.http.post(`${baseUrl}/project/addUpdateOtcProject`, data);
  },
  loadOtcProject(data) {
    return Vue.http.post(`${baseUrl}/project/loadOtcProject`, data);
  },
  deleteOtcProject(data) {
    return Vue.http.post(`${baseUrl}/project/deleteOtcProject`, data);
  },
  otcCustomer(data) {
    return Vue.http.post(`${baseUrl}/customer/otcCustomer`, data);
  },
  otcList(data) {
    return Vue.http.post(`${baseUrl}/visit/otcList`, data);
  },
  updateOtcAuditStatus(data) {
    return Vue.http.post(`${baseUrl}/visit/updateOtcAuditStatus`, data);
  },
  exportOtcVisitData: `${baseUrl}/visit/exportOtcVisitData`,
  provinceCityList(data) {
    return Vue.http.post(`${baseUrl}/project/provinceCityList`, data);
  },
  otcVisitPlanDetail(data) {
    return Vue.http.post(`${baseUrl}/visit/otcVisitPlanDetail`, data);
  }
};
export const search = {
  crmEnterpriseList(data) {
    return Vue.http.post(`${baseUrl}/industryProject/crmEnterpriseList`, data);
  },
  yshEnterpriseList(data) {
    return Vue.http.post(`${baseUrl}/industryProject/yshEnterpriseList`, data);
  }
};
// 项目
export const project = {
  obtainCsoEnterprise(data) {
    return Vue.http.post(`${baseUrl}/project/obtainCsoEnterprise`, data);
  },
  demandProjectList(data) {
    return Vue.http.post(`${baseUrl}/project/demandProjectList`, data);
  },
  updateNumberProject(data) {
    //数字拜访
    return Vue.http.post(
      `${baseUrl}/industryProject/updateNumberProject`,
      data
    );
  },
  loadNumberProject(data) {
    return Vue.http.post(`${baseUrl}/industryProject/loadNumberProject`, data);
  },
  numVisitPlanList(data) {
    //数字拜访详情里的列表
    return Vue.http.post(`${baseUrl}/numberVisit/visitPlanList`, data);
  },
  visitPlanDetail(data) {
    //数字拜访详情列表里的详情
    return Vue.http.post(`${baseUrl}/numberVisit/visitPlanDetail`, data);
  },
  projectSzVisitType(data) {
    //判断数字拜访类型
    return Vue.http.post(`${baseUrl}/industryProject/projectSzVisitType`, data);
  },
  //项目-任务分配列表
  taskList(data) {
    return Vue.http.post(`${baseUrl}/projectTask/taskList`, data);
  },
  // -项目-任务-提交
  submitTask(data) {
    return Vue.http.post(`${baseUrl}/projectTask/submitTask`, data);
  },
  // -项目-任务-提交
  importXsbfData: `${baseUrl}/projectTask/importXsbfData`,
  exportNumbervisitRecord: `${baseUrl}/export/exportNumbervisitRecord`,
  //学术拜访列表 项目类型  1学术拜访  2 OTC巡访  3 科室会  4 患教会
  projectList(data) {
    return Vue.http.post(`${baseUrl}/industryProject/projectList`, data);
  },
  //任务列表
  projectIndustryList(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/projectIndustryList`,
      data
    );
  },
  //任务详情
  projectIndustryDetail(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/projectIndustryDetail`,
      data
    );
  },
  //修改任务
  projectIndustryUpdate(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/projectIndustryUpdate`,
      data
    );
  },
  //学术拜访-加载单条数据
  loadXueshuProject(data) {
    return Vue.http.post(`${baseUrl}/industryProject/loadXueshuProject`, data);
  },
  //拜访计划任务详情列表
  visitPlanList(data) {
    return Vue.http.post(`${baseUrl}/industryProject/visitPlanList`, data);
  },
  //CRM获取企业
  crmEnterpriseList(data) {
    return Vue.http.post(`${baseUrl}/industryProject/crmEnterpriseList`, data);
  },
  //医生汇获取企业
  yshEnterpriseList(data) {
    return Vue.http.post(`${baseUrl}/industryProject/yshEnterpriseList`, data);
  },
  //科室会-加载单条数据
  loadDepartmentProject(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/loadDepartmentProject`,
      data
    );
  },
  //1'学术拜访', 2'OTC拜访', 3'科室会', 4'患教会', 5'医学助手项目调研', 6'线上推广',
  // 7'医生调查问卷', 8'病例收集', 9'等级医院拜访', 10'基层医疗机构拜访', 11'特级三甲医院市场准入',
  // 12'三级医院市场准入', 13'二级医院市场准入', 14'基层医疗机构市场准入', 15'零售药店市场准入', 16'AI健康管理'

  //科室会-修改产品项目
  addUpdateDepartmentProject(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/addUpdateDepartmentProject`,
      data
    );
  },
  //OTC拜访-修改产品项目
  addUpdateOtcProject(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/addUpdateOtcProject`,
      data
    );
  },
  //等级医院
  addUpdatelvlProject(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/addUpdateGradeHospitalProject `,
      data
    );
  },
  //基层医疗机构-修改项目
  addUpdateBaseProject(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/addUpdateMedicalOrgProject`,
      data
    );
  },
  //学术拜访-修改项目
  addUpdateXueshuProject(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/addUpdateXueshuProject`,
      data
    );
  },
  //患教会-修改患教会项目
  addUpdatePatientProject(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/addUpdatePatientProject`,
      data
    );
  },
  //市场准入项目修改
  addUpdateHospitalAndOtcMarketAccessProject(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/addUpdateHospitalAndOtcMarketAccessProject`,
      data
    );
  },
  //医学助手调查问卷内容修改
  addUpdateDcwj(data) {
    return Vue.http.post(`${baseUrl}/dcwj/addUpdateDcwj`, data);
  },

  //OTC拜访-加载单条数据
  loadOtcProject(data) {
    return Vue.http.post(`${baseUrl}/industryProject/loadOtcProject`, data);
  },
  industryConfirm(data) {
    //甲方项目接收
    return Vue.http.post(`${baseUrl}/industryProject/industryConfirm`, data);
  },
  //患教会-加载单条数据
  loadPatientProject(data) {
    return Vue.http.post(`${baseUrl}/industryProject/loadPatientProject`, data);
  },
  departmentVisitPlanList(data) {
    //科室会拜访记录
    return Vue.http.post(
      `${baseUrl}/industryProject/departmentVisitPlanList`,
      data
    );
  },
  otcVisitPlanList(data) {
    //otc拜访记录
    return Vue.http.post(`${baseUrl}/industryProject/otcVisitPlanList`, data);
  },
  patientVisitPlanList(data) {
    //患教会
    return Vue.http.post(
      `${baseUrl}/industryProject/patientVisitPlanList`,
      data
    );
  },
  crmProjectList(data) {
    return Vue.http.post(`${baseUrl}/industryProject/crmProjectList`, data);
  },
  dcwjList(data) {
    //医学助手调查问卷列表
    return Vue.http.post(`${baseUrl}/dcwj/dcwjList`, data);
  },
  dcwjIndustryList(data) {
    //医学助手调查问卷任务列表
    return Vue.http.post(`${baseUrl}/dcwj/dcwjIndustryList`, data);
  },
  dcwjProjectIndustryUpdate(data) {
    //医学助手调查问卷任务修改
    return Vue.http.post(`${baseUrl}/dcwj/projectIndustryUpdate`, data);
  },
  loadDcwj(data) {
    //医学助手调查问卷详情
    return Vue.http.post(`${baseUrl}/dcwj/loadDcwj`, data);
  },
  dcwjIndustryConfirm(data) {
    //医学助手调查问卷任务甲方确认
    return Vue.http.post(`${baseUrl}/dcwj/industryConfirm`, data);
  },
  yshDcwjList(data) {
    //医生汇调查问卷列表
    return Vue.http.post(`${baseUrl}/dcwj/yshDcwjList`, data);
  },
  yshDcwjIndustryList(data) {
    //医生汇调查问卷任务列表
    return Vue.http.post(`${baseUrl}/dcwj/yshDcwjIndustryList`, data);
  },
  yshProjectIndustryUpdate(data) {
    //医生汇调查问卷任务修改
    return Vue.http.post(`${baseUrl}/dcwj/yshProjectIndustryUpdate`, data);
  },
  yshLoadDcwj(data) {
    //医生汇调查问卷详情
    return Vue.http.post(`${baseUrl}/dcwj/yshLoadDcwj`, data);
  },
  yshAddUpdateDcwj(data) {
    //医生汇调查问卷内容修改
    return Vue.http.post(`${baseUrl}/dcwj/yshAddUpdateDcwj`, data);
  },
  yshIndustryConfirm(data) {
    //医生汇调查问卷任务甲方确认
    return Vue.http.post(`${baseUrl}/dcwj/yshIndustryConfirm`, data);
  },

  dcwjEnterpriseList(data) {
    //医生汇调查问卷任务甲方确认
    return Vue.http.post(`${baseUrl}/industryProject/dcwjEnterpriseList`, data);
  },
  selectProjectList(data) {
    //首页全部项目列表
    return Vue.http.post(`${baseUrl}/project/selectProjectList`, data);
  },
  questionnaireAnswerList(data) {
    //调查问卷记录列表
    return Vue.http.post(
      `${baseUrl}/questionnaire/questionnaireAnswerList`,
      data
    );
  },
  questionnaireAnswerDetail(data) {
    //调查问卷详情
    return Vue.http.post(
      `${baseUrl}/questionnaire/questionnaireAnswerDetail`,
      data
    );
  },
  questMakeSceneBaseProjectAnswerList(data) {
    //可配置场景记录列表
    return Vue.http.post(
      `${baseUrl}/questionnaire/questMakeSceneBaseProjectAnswerList`,
      data
    );
  },
  questMakeSceneBaseProjectAnswerListDetail(data) {
    //可配置场景问卷详情
    return Vue.http.post(
      `${baseUrl}/questionnaire/questMakeSceneBaseProjectAnswerListDetail`,
      data
    );
  },
  exporXsbftData: `${baseUrl}/export/exporXsbftData`, // 导出学术拜访表格
  exportVisitPlanExcel: `${baseUrl}/export/exportVisitPlanExcel`, //导出功能
  taskHzDyRecordDiaoyanPageListExportV2: `${baseUrl}/export/taskHzDyRecordDiaoyanPageListExportV2`, //导出患者调研
  taskYxDyRecordDiaoyanPageListExportV2: `${baseUrl}/export/taskYxDyRecordDiaoyanPageListExportV2`, //导出医学调研
  exportOtcVisitPlanExcel: `${baseUrl}/export/exportOtcVisitPlanExcel`,
  exportDepartmentVisitPlanExcel: `${baseUrl}/export/exportDepartmentVisitPlanExcel`,
  exportPatientVisitPlanExcel: `${baseUrl}/export/exportPatientVisitPlanExcel`,
  exportHgtgExcel: `${baseUrl}/export/exportHgtgExcel`,
  taskmakeSceneBaseProjectAnswerPageListExportV2: `${baseUrl}/export/taskmakeSceneBaseProjectAnswerPageListExportV2`,
  hospitalVisitPlanList(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/gradeHospitalAndMedicalOrgList`,
      data
    );
  },
  hospitalTaskDetail(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/selectGradeHospitalAndMedicalOrgDetail`,
      data
    );
  },
  loadHospitalProject(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/loadGradeHospitalAndMedicalOrgProject`,
      data
    );
  },
  hospitalOrOtcMarketAccessList(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/hospitalOrOtcMarketAccessList`,
      data
    );
  },
  loadHospitalAndOtcMarketAccessProject(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/loadHospitalAndOtcMarketAccessProject`,
      data
    );
  },
  hospitalExport: `${baseUrl}/export/exportGradeHospitalAndMedicalOrgList`,
  exportHospitalOrOtcMarketAccessList: `${baseUrl}/export/exportHospitalOrOtcMarketAccessList`
};

export const bingli = {
  // 病例
  // 病例管理
  bingliList(data) {
    return Vue.http.post(`${baseUrl}/bingli/bingliList`, data);
  },
  //病例项目管理
  projectList(data) {
    return Vue.http.post(`${baseUrl}/industryProject/yshProjectList`, data);
  },
  //病例项目管理-修改病例
  addUpdateBingliProject(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/updateBingliProject`,
      data
    );
  },
  //病例项目管理-项目数据
  loadProject(data) {
    return Vue.http.post(`${baseUrl}/industryProject/loadBingliProject`, data);
  },
  loadProject2(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/loadBingliXcxProject18`,
      data
    );
  },
  //病例项目-分配任务列表
  bingliProjectTask(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/yshProjectIndustryList`,
      data
    );
  },
  //病例管理-修改
  addUpdateBingli(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/updateBingliProject`,
      data
    );
  },
  //修改病例任务
  yshProjectIndustryUpdate(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/yshProjectIndustryUpdate`,
      data
    );
  },
  yshIndustryConfirm(data) {
    //甲方接收
    return Vue.http.post(`${baseUrl}/industryProject/yshIndustryConfirm`, data);
  },
  projectBingLiList(data) {
    return Vue.http.post(`${baseUrl}/industryProject/projectBingLiList`, data);
  },
  exportBingLiExcel: `${baseUrl}/export/exportBingLiExcel`
};
export const zsBingli = {
  // 助手病例
  // 病例管理
  bingliList(data) {
    return Vue.http.post(`${baseUrl}/bingli/bingliList`, data);
  },
  //病例项目管理
  projectList(data) {
    return Vue.http.post(`${baseUrl}/industryProject/yshProjectList`, data);
  },
  //病例项目管理-修改病例
  addUpdateBingliProject(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/updateBingliXcxProject18`,
      data
    );
  },
  //病例项目管理-项目数据
  loadProject(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/loadBingliXcxProject18`,
      data
    );
  },
  //病例项目-分配任务列表
  bingliProjectTask(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/xcxProjectIndustryList`,
      data
    );
  },
  //病例管理-修改
  addUpdateBingli(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/updateBingliXcxProject18`,
      data
    );
  },
  //修改病例任务
  yshProjectIndustryUpdate(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/xcxProjectIndustryUpdate`,
      data
    );
  },
  yshIndustryConfirm(data) {
    //甲方接收
    return Vue.http.post(`${baseUrl}/industryProject/xcxIndustryConfirm`, data);
  },
  projectBingLiList(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/xcxprojectBingLiList`,
      data
    );
  },
  exportBingLiExcel: `${baseUrl}/export/xcxExportBingLiExcel`
};
//协定服务
export const protocolService = {
  loadAgreementServiceInfo(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/loadAgreementServiceInfo`,
      data
    );
  },
  addUpdateAgreementService(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/addUpdateAgreementService`,
      data
    );
  },
  queryAgreementServiceDetailList(data) {
    return Vue.http.post(
      `${baseUrl}/industryProject/queryAgreementServiceDetailList`,
      data
    );
  },
  exportAgreementServiceDetailList: `${baseUrl}/industryProject/exportAgreementServiceDetailList`,
  downloadAgreementServiceFile: `${baseUrl}/upload/downloadAgreementServiceFile`
};

export const uploadImage = `${baseUrl}/upload/image`;

export const information = {
  //资讯
  informationList(data) {
    return Vue.http.post(`${baseUrl}/information/informationList`, data);
  },
  saveInformation(data) {
    return Vue.http.post(`${baseUrl}/information/saveInformation`, data);
  },
  loadInformationVideo(data) {
    return Vue.http.post(`${baseUrl}/information/loadInformationVideo`, data);
  },
  deleteInformationVideo(data) {
    return Vue.http.post(`${baseUrl}/information/deleteInformationVideo`, data);
  },
  channelProjectList(data) {
    return Vue.http.post(`${baseUrl}/information/channelProjectList`, data);
  }
};
export const AI = {
  //AI健康管理
  addUpdateAiProject(data) {
    return Vue.http.post(`${baseUrl}/industryProject/addUpdateAiProject`, data);
  },
  loadAIProject(data) {
    return Vue.http.post(`${baseUrl}/industryProject/loadAIProject`, data);
  }
};
export const eContract = {
  //资讯
  firstSign(data) {
    return Vue.http.post(`${baseUrl}/sign/firstSign`, data);
  },
  firstYshSign(data) {
    return Vue.http.post(`${baseUrl}/sign/firstYshSign`, data);
  },
  enterpriseList(data) {
    return Vue.http.post(`${baseUrl}/sign/enterpriseList`, data);
  },
  signList(data) {
    return Vue.http.post(`${baseUrl}/sign/signList`, data);
  },
  lookContract(data) {
    return Vue.http.post(`${baseUrl}/sign/lookContract`, data);
  },
  downloadContractUrl: `${baseUrl}/sign/downloadUrl`,
  downloadContract(data) {
    return Vue.http.get(`${baseUrl}/sign/downloadUrl`, {
      params: data
    });
  },
  // 根据项目id获取项目信息
  queryserviceSubitem(data) {
    return Vue.http.post(`${baseUrl}/sign/queryserviceSubitem`, data);
  }
};

export const channel = {
  //专区
  channelList(data) {
    return Vue.http.post(`${baseUrl}/channel/channelList`, data);
  },
  selectMonthTaskPerson(data) {
    return Vue.http.post(`${baseUrl}/channel/selectMonthTaskPerson`, data);
  },
  projectList(data) {
    return Vue.http.post(`${baseUrl}/channel/projectList`, data);
  },
  deleteChannel(data) {
    return Vue.http.post(`${baseUrl}/channel/deleteChannel`, data);
  },
  loadChannel(data) {
    return Vue.http.post(`${baseUrl}/channel/loadChannel`, data);
  },
  addUpdateChannel(data) {
    return Vue.http.post(`${baseUrl}/channel/addUpdateChannel`, data);
  },
  picUrlInformation(data) {
    return Vue.http.post(`${baseUrl}/channel/picUrlInformation`, data);
  },
  channelInformationList(data) {
    return Vue.http.post(`${baseUrl}/channel/channelInformationList`, data);
  },
  loadChannelProject(data) {
    return Vue.http.post(`${baseUrl}/channelProject/loadChannelProject`, data);
  },
  updateChannelProject(data) {
    return Vue.http.post(
      `${baseUrl}/channelProject/updateChannelProject`,
      data
    );
  },
  selectChannel(data) {
    return Vue.http.post(`${baseUrl}/channelProject/selectChannel`, data);
  },
  selectMonthTask(data) {
    return Vue.http.post(`${baseUrl}/channel/selectMonthTask`, data);
  },
  getMonthTask(data) {
    return Vue.http.post(`${baseUrl}/channel/getMonthTask`, data);
  }
};
export const BI = {
  // 通用接口
  common: {
    // 查询项目基础信息-报表头部显示
    queryProjectBaseInfo(data) {
      return Vue.http.post(`${baseUrl}/bi/biVisit/queryProjectBaseInfo`, data, {
        notUseQs: true,
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      });
    },
    // 查询项目在某一任务月度下的自然人年龄及性别信息
    queryAllianceUserInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/biVisit/queryAllianceUserInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 上传文件
    fileUpload(data) {
      return Vue.http.post(`${baseUrl}/upload/fileUploadProjectBI`, data);
    }, // 下载
    addPdf2TaskDownload(data) {
      return Vue.http.post(
        `${baseUrl}/bi/makeSceneController/addPdf2TaskDownload`,
        data
      );
    }, // 下载
    addPdfOrPng2TaskDownload(data) {
      return Vue.http.post(
        `${baseUrl}/bi/makeSceneController/addPdfOrPng2TaskDownload`,
        data
      );
    }
  },
  // 问卷
  dcwj: {
    // 问卷题型
    queryQuestionnaireDetailInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/dcwjController/queryQuestionnaireDetailInfo`,
        data
      );
    }, // 查询项目在某一任务月度下的自然人年龄及性别信息
    queryAllianceUserInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/dcwjController/queryAllianceUserInfo`,
        data
      );
    },
    // 查询项目下不同状态的任务数统计
    querytaskStatusTotalInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/dcwjController/querytaskStatusTotalInfo`,
        data
      );
    },
    // 查询项目下各阶段任务完成量的人数统计
    queryTaskSumTotalInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/dcwjController/queryTaskSumTotalInfo`,
        data
      );
    }
  },
  // 可配置场景
  makeScene: {
    // 问卷题型
    queryQuestionnaireDetailInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/makeSceneController/queryQuestionnaireDetailInfo`,
        data
      );
    }, // 查询项目在某一任务月度下的自然人年龄及性别信息
    queryAllianceUserInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/makeSceneController/queryAllianceUserInfo`,
        data
      );
    },
    // 可配置场景目标题型
    queryQuestionnaireTargetDetailInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/makeSceneController/queryQuestionnaireTargetDetailInfo`,
        data
      );
    },
    // 可配置场景时间题型
    queryQuestionnaireTimeTargetDetailInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/makeSceneController/queryQuestionnaireTimeTargetDetailInfo`,
        data
      );
    },
    // 可配置场景定位题型
    queryQuestionnaireAddressTargetDetailInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/makeSceneController/queryQuestionnaireAddressTargetDetailInfo`,
        data
      );
    },
    // 查询项目下不同状态的任务数统计
    querytaskStatusTotalInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/makeSceneController/querytaskStatusTotalInfo`,
        data
      );
    },
    // 查询项目下各阶段任务完成量的人数统计
    queryTaskSumTotalInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/makeSceneController/queryTaskSumTotalInfo`,
        data
      );
    }
  },
  jcyljg: {
    // 查询客户反馈统计信息
    queryCustomerFeedBack(data) {
      return Vue.http.post(
        `${baseUrl}/bi/jcyljgController/queryCustomerFeedBack`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    }, // 查询项目在某一任务月度下的自然人年龄及性别信息
    queryAllianceUserInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/biVisit/queryAllianceUserInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询医院分类统计信息
    queryHospitalCategoryInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/jcyljgController/queryHospitalCategoryInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下各阶段任务完成量的人数统计
    queryTaskSumTotalInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/biVisit/queryTaskSumTotalInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询拜访时长统计信息
    queryVisitMinuteInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/jcyljgController/queryVisitMinuteInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询拜访时间统计信息
    queryVisitTimeInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/jcyljgController/queryVisitTimeInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下不同状态的任务数统计
    querytaskStatusTotalInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/biVisit/querytaskStatusTotalInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 照片墙
    querytaskImgs(data) {
      return Vue.http.post(
        `${baseUrl}/bi/jcyljgController/querytaskImgs`,
        data
      );
    }
  },
  otc: {
    // 查询客户陈列状态 库存，是否有Pop，店员是知晓Pop 等信息
    queryOtcCustomerProductInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/otcController/queryOtcCustomerProductInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    }, // 查询项目在某一任务月度下的自然人年龄及性别信息
    queryAllianceUserInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/biVisit/queryAllianceUserInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询产品价格信息
    queryOtcProductPriceInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/otcController/queryOtcProductPriceInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下不同状态的任务数统计
    querytaskStatusTotalInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/biVisit/querytaskStatusTotalInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下各阶段任务完成量的人数统计
    queryTaskSumTotalInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/biVisit/queryTaskSumTotalInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询巡店时间信息，按日，按小时统计
    queryOtcVisitTimeInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/otcController/queryOtcVisitTimeInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 照片墙
    querytaskImgs(data) {
      return Vue.http.post(`${baseUrl}/bi/otcController/querytaskImgs`, data);
    },
    // 照片墙
    queryOtcTaskLocationInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/otcController/queryOtcTaskLocationInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    }
  },
  gradeHospital: {
    // 任务审核状态接口
    querytaskStatusTotalInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/biVisit/querytaskStatusTotalInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    }, // 查询项目在某一任务月度下的自然人年龄及性别信息
    queryAllianceUserInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/biVisit/queryAllianceUserInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 项目参与人执行任务表
    queryTaskSumTotalInfo(data) {
      return Vue.http.post(
        `${baseUrl}/bi/biVisit/queryTaskSumTotalInfo`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下拜访医院分布
    querytaskHospitalDistribution(data) {
      return Vue.http.post(
        `${baseUrl}/bi/gradeHospitalVisit/querytaskHospitalDistribution`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下拜访医院的照片
    querytaskImgs(data) {
      return Vue.http.post(
        `${baseUrl}/bi/gradeHospitalVisit/querytaskImgs`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下医院等级分布
    querytaskHospitalGradeDistribution(data) {
      return Vue.http.post(
        `${baseUrl}/bi/gradeHospitalVisit/querytaskHospitalGradeDistribution`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下科室分布
    querytaskDepartmentDistribution(data) {
      return Vue.http.post(
        `${baseUrl}/bi/gradeHospitalVisit/querytaskDepartmentDistribution`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下医院职称分布
    querytaskHospitalTitleDistribution(data) {
      return Vue.http.post(
        `${baseUrl}/bi/gradeHospitalVisit/querytaskHospitalTitleDistribution`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下拜访时间
    querytaskVisitingTime(data) {
      return Vue.http.post(
        `${baseUrl}/bi/gradeHospitalVisit/querytaskVisitingTime`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    },
    // 查询项目下拜访时长
    querytaskLengthVisit(data) {
      return Vue.http.post(
        `${baseUrl}/bi/gradeHospitalVisit/querytaskLengthVisit`,
        data,
        {
          notUseQs: true,
          headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        }
      );
    }
  }
};
/****************************************************下载中心****************************************************************/
// 下载中心列表
export const taskDownloadList = async data => {
  // 改造接口
  const resp = await Vue.http.post(`${baseUrl}/task/taskDownloadList`, data);
  const {
    pdata: { list }
  } = resp;
  list.forEach(item => {
    // 所有下载情况都使用taskRecordUrls字段，length为1点击下载直接下载，为2点击下载出现弹层列表
    if (!item.taskRecordUrls) {
      // 所有资源都是downloadUrl，没有taskRecordUrl
      if (item.downloadUrl) {
        item.taskRecordUrls = [
          {
            downloadName: item.downloadName,
            downloadUrl: item.downloadUrl,
            fileSize: item.fileSize,
            urlStatus: 1 // 整理的数据设置为1，方便统一处理。只有自定义的链接有失效。1有效\2失效
          }
        ];
      } else {
        item.taskRecordUrls = [];
      }
    }
  });
  return resp;
};
/****************************************************个人下载****************************************************************/
export const personalBI = {
  // 协定服务批量
  startBiDownloadTask(data) {
    return Vue.http.post(`${baseUrl}/bitask/startBiDownloadTask`, data);
  },
  // 协定服务全部
  startAgreementServiceBiDownloadTask(data) {
    return Vue.http.post(
      `${baseUrl}/bitask/startAgreementServiceBiDownloadTask`,
      data
    );
  },
  // 1学术拜访  2 OTC  3 科室会  4 患教会  9 等级医院拜访  10基层医疗机构拜访 11 特级三甲医院市场准入  12 三级医院市场准入  13 二级医院市场准入  14 基层医疗机构市场准入 15 零售药店市场准入
  addVisitBIZipTask(data) {
    return Vue.http.post(`${baseUrl}/BIExprot/addVisitBIZipTask`, data);
  },
  // 线上推广
  num6(data) {
    return Vue.http.post(`${baseUrl}/bi/downloadAcademicVisitBIZip/num6`, data);
  },
  // 数字拜访
  num17(data) {
    return Vue.http.post(
      `${baseUrl}/bi/downloadAcademicVisitBIZip/num17`,
      data
    );
  },
  // Bi 个人报表导出任务申请（单月任务） 可配置场景
  kpzIdYEport(data) {
    return Vue.http.post(`${baseUrl}/KpzBIExprot/kpzIdYEport`, data);
  },
  // BI 个人报表导出任务申请 （多月度）可配置场景
  kpzAllYEport(data) {
    return Vue.http.post(`${baseUrl}/KpzBIExprot/kpzAllYEport`, data);
  },
  // Bi 个人报表导出任务申请（单月任务） 患者调研场景
  hzdyIdYEport(data) {
    return Vue.http.post(`${baseUrl}/hzdYBIExprot/hzdyIdYEport`, data);
  },
  // Bi 个人报表导出任务申请 （多月度）患者调研
  hzdyAllYEport(data) {
    return Vue.http.post(`${baseUrl}/hzdYBIExprot/hzdyAllYEport`, data);
  },
  // 医生病历 批量
  DocBlIdEport(data) {
    return Vue.http.post(`${baseUrl}/docBingliBIExprot/DocBlIdEport`, data);
  },
  // 医生病历 全部
  DocBlAllYEport(data) {
    return Vue.http.post(`${baseUrl}/docBingliBIExprot/DocBlAllYEport`, data);
  },
  // 助手病例Bi 个人报表导出任务申请（单月任务）
  startCaseBiDownloadTaskByIds(data) {
    return Vue.http.post(
      `${baseUrl}/bitask/startCaseBiDownloadTaskByIds`,
      data
    );
  },
  // 助手病例Bi 个人报表导出任务申请 （多月度）
  startCaseBiDownloadTask(data) {
    return Vue.http.post(`${baseUrl}/bitask/startCaseBiDownloadTask`, data);
  }
};
/********************************************子账号管理********************************************/
export const subAccount = {
  // 首页项目分配/子账号列表/分配
  assignProjectPerm(data) {
    return Vue.http.post(
      `${baseUrl}/subaccountManagement/assignProjectPerm`,
      data
    );
  },
  // 首页项目列表/子账号下拉菜单
  selectOptions(data) {
    return Vue.http.post(
      `${baseUrl}/subaccountManagement/querySubAccount`,
      data
    );
  },
  // 首页项目分配/子账号列表
  indexList(data) {
    return Vue.http.post(`${baseUrl}/subaccountManagement/indexList`, data);
  }
};

/****************************************************任务记录****************************************************************/
export const company = {
  //企业管理
  list(data) {
    return Vue.http.post(`${basePath}/enterprise/list`, data);
  }, //获取LIST
  listA(data) {
    return Vue.http.post(`${basePath}/enterprise/list`, data);
  },
  //乙方企业列表
  listB(data) {
    return Vue.http.post(
      `${basePath}/taskRecordAndSummaryDoc/queryCsoEnterprise`,
      data
    );
  },
  //获取服务商/工业方
  listC(data) {
    return Vue.http.post(`${basePath}/contract/listEnterprise`, data);
  },
  /**
   * 公司下的项目
   * POST /rest/crm/oss/taskRecordAndSummaryDoc/queryCsoProject
   */
  projectList(data) {
    return Vue.http.post(
      `${basePath}/taskRecordAndSummaryDoc/queryCsoProject`,
      data
    );
  },

  add(data) {
    return Vue.http.post(`${basePath}/enterprise/save`, data);
  },
  del(data) {
    return Vue.http.post(`${basePath}/enterprise/delete`, data);
  },
  // 供应商列表
  listP(data) {
    return Vue.http.post(`${basePath}/invoice/querySupplierName`, data);
  },
  // 工业列表
  listI(data) {
    return Vue.http.post(
      `${basePath}/taskRecordAndSummaryDoc/queryIndustryEnterpriseInfo`,
      data
    );
  },
  // 合同管理-工业列表
  listIndustrys(data) {
    return Vue.http.post(`${basePath}/contract/industrys`, data);
  },
  // 合同管理-工业列表
  listProjectEnterprises(data) {
    return Vue.http.post(`${basePath}/contract/projectEnterprises`, data);
  }
};
export const aAlly = {
  // 通过状态改为不通过
  taskNotPass(data) {
    return Vue.http.post(`${basePath}/taskRecordAndSummary/taskNotPass`, data);
  },
  /*批量不通过*/
  taskNotPassAll(data) {
    return Vue.http.post(
      `${basePath}/taskRecordAndSummary/updateTaskNotPassPlans`,
      data
    );
  },
  //学术拜访
  xsbf: {
    part0: {
      list(data) {
        //1学术拜访  2 OTC巡访  3 科室会
        Object.assign(data, {
          projectType: 1
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskRecordPageList`,
          data
        );
      },
      listSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/signingCompanyItemList`,
          data
        );
      },
      detail222(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      detailSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      taskExport(data) {
        return `${basePath}/taskRecordAndSummary/xsbfTaskRecordExport?projectType=1&`;
      }
    },
    part1: {
      list(data) {
        Object.assign(data, {
          projectType: 3
        });

        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskSummaryPageList`,
          data
        );
      },
      taskExport(data) {
        // Object.assign(data, {projectType: 3});
        return `${basePath}/taskRecordAndSummary/taskSummaryPageListExport?projectType=3&`;
      }
    }
  },
  otc: {
    part0: {
      list(data) {
        Object.assign(data, {
          projectType: 2
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskRecordPageList`,
          data
        );
      },
      listSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/signingCompanyItemList`,
          data
        );
      },
      detail(data) {
        //POST /rest/crm/oss/taskRecordAndSummary/otcTaskQuery
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/otcTaskQuery`,
          data
        );
      },
      detailSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      edit(data) {
        return Vue.http.post(`${basePath}/addUpdateSigningCompanyItem`, data);
      },
      taskExport(data) {
        return `${basePath}/taskRecordAndSummary/otcTaskRecordExport`;
      }
    },
    part1: {
      list(data) {
        Object.assign(data, {
          projectType: 4
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskSummaryPageList`,
          data
        );
      },
      taskExport(data) {
        // Object.assign(data, {projectType: 4});
        return `${basePath}/taskRecordAndSummary/taskSummaryPageListExport?projectType=4&`;
      }
    }
  },
  //患者调研 医学调研
  hzdy: {
    part0: {
      list(data) {
        // POST /rest/crm/oss/taskRecordAndSummaryDoc/taskRecordDiaoyanPageList
        // Object.assign(data, {projectType: 3});/taskRecordAndSummaryDoc/taskRecordDiaoyanSummary
        //POST /rest/crm/oss/taskRecordAndSummary/hzdyTaskRecordPageList
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/hzdyTaskRecordPageList`,
          data
        );
      },
      listSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/signingCompanyItemList`,
          data
        );
      },
      //POST /rest/crm/oss/taskRecordAndSummary/hzdyTaskQuery
      detail(data) {
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/hzdyTaskQuery`,
          data
        );
      },
      detailSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      edit(data) {
        return Vue.http.post(`${basePath}/addUpdateSigningCompanyItem`, data);
      },
      taskExport(data) {
        return `${basePath}/taskRecordAndSummary/hzdyTaskRecordExport`;
      },
      taskExport2(data) {
        return `${basePath}/taskRecordAndSummary/taskRecordDiaoyanPageListExportV2`;
      }
    },
    part1: {
      list(data) {
        //POST /rest/crm/oss/taskRecordAndSummary/hzdySummaryPageList
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/hzdySummaryPageList`,
          data
        );
      },
      taskExport(data) {
        // Object.assign(data, {projectType: 5});
        return `${basePath}/taskRecordAndSummary/hzdyTaskSummaryExport`;
      }
    }
  },
  //科室会
  ksh: {
    part0: {
      list(data) {
        Object.assign(data, {
          projectType: 3
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskRecordPageList`,
          data
        );
      },
      listSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/signingCompanyItemList`,
          data
        );
      },
      detail(data) {
        //POST /rest/crm/oss/taskRecordAndSummary/kshTaskQuery
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/kshTaskQuery`,
          data
        );
      },
      detailSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      edit(data) {
        return Vue.http.post(`${basePath}/addUpdateSigningCompanyItem`, data);
      },
      taskExport(data) {
        return `${basePath}/taskRecordAndSummary/kshTaskRecordExport`;
      }
    },
    part1: {
      list(data) {
        /**
         * OSS 线上推广 任务汇总 出参：[{乙方企业、项目名称、任务月度、项目参与人、手机号、(taskSum)计划任务量、实际完成量(finishSum)、未完成量(0)、审核通过量(finishSum)、任务完成率(实际完成量/计划任务量)}]
         */
        Object.assign(data, {
          projectType: 5
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskSummaryPageList`,
          data
        );
      },
      taskExport(data) {
        // Object.assign(data, {projectType: 5});
        return `${basePath}/taskRecordAndSummary/taskSummaryPageListExport?projectType=5&`;
      }
    }
  },
  //  POST /rest/crm/oss/onlinepro/taskRecord
  //患教会
  hjh: {
    part0: {
      list(data) {
        /**
         * OSS 线上推广 任务记录 出参：[{专区ID(channelId),csoId,乙方企业(enterpriseName)、projectId,项目名称(projectName)、任务月度(taskDt)、项目参与人(fullName)、手机号(phone)、点击数(finishSum)}]
         */
        //GET /rest/crm/oss/taskRecordAndSummaryDoc/taskRecordHjhPageList
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryDoc/taskRecordHjhPageList`,
          data
        );
      },
      //GET /rest/crm/oss/taskRecordAndSummaryDoc/taskRecordHjhSummary
      listSum(data) {
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryDoc/taskRecordHjhSummary`,
          data
        );
      },
      // 详情查看
      detail(data = {}) {
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryDoc/taskRecordHjhQdInfo`,
          data
        );
      },
      detailSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      taskExport(data) {
        //GET /rest/crm/oss/taskRecordAndSummaryDoc/taskRecordHjhPageListExport
        return `${basePath}/taskRecordAndSummaryDoc/taskRecordHjhPageListExport`;
      },
      edit(data) {
        return Vue.http.post(`${basePath}/addUpdateSigningCompanyItem`, data);
      }
    },
    //  POST /rest/crm/oss/onlinepro/tasksummary
    part1: {
      list(data) {
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryDoc/taskRecordHjhSummary`,
          data
        );
      },
      taskExport(data) {
        return `${basePath}/taskRecordAndSummaryDoc/taskRecordHjhSummaryExport`;
      }
    }
  },
  //线上推广
  xstg: {
    //  POST /rest/crm/oss/onlinepro/taskRecord
    part0: {
      list(data) {
        /**
         * OSS 线上推广 任务记录 出参：[{专区ID(channelId),csoId,乙方企业(enterpriseName)、projectId,项目名称(projectName)、任务月度(taskDt)、项目参与人(fullName)、手机号(phone)、点击数(finishSum)}]
         */
        return Vue.http.post(`${basePath}/onlinepro/taskRecord`, data);
      },
      listSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/signingCompanyItemList`,
          data
        );
      },
      detail(data) {
        return Vue.http.post(`${basePath}/onlinepro/taskRecordView`, data);
      },
      detailSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      taskExport(data) {
        return `${basePath}/onlinepro/taskRecordExport`;
      },
      edit(data) {
        return Vue.http.post(`${basePath}/addUpdateSigningCompanyItem`, data);
      },
      taskExport2(data) {
        return `${basePath}/onlinepro/taskRecordExportV2`;
      },
      taskExport3(data) {
        return `${basePath}/onlinepro/taskRecordExportForIndustry`;
      }
    },
    //  POST /rest/crm/oss/onlinepro/tasksummary
    part1: {
      list(data) {
        /**
         * OSS 线上推广 任务汇总 出参：[{乙方企业、项目名称、任务月度、项目参与人、手机号、(taskSum)计划任务量、实际完成量(finishSum)、未完成量(0)、审核通过量(finishSum)、任务完成率(实际完成量/计划任务量)}]
         */
        return Vue.http.post(`${basePath}/onlinepro/tasksummary`, data);
      },
      taskExport(data) {
        return `${basePath}/onlinepro/tasksummaryExport`;
      }
    }
  },
  //特级三甲医院
  tjsjyy: {
    part0: {
      list(data) {
        //1学术拜访  2 OTC巡访  3 科室会  9  等级医院拜访  10  基层医疗机构拜访
        Object.assign(data, {
          projectType: 9
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskRecordPageList`,
          data
        );
      },
      listSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/signingCompanyItemList`,
          data
        );
      },
      detailSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      taskExport(data) {
        return `${basePath}/taskRecordAndSummary/xsbfTaskRecordExport?projectType=9&`;
      }
    },
    part1: {
      list(data) {
        Object.assign(data, {
          projectType: 9
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskSummaryPageList`,
          data
        );
      },
      taskExport(data) {
        // Object.assign(data, {projectType: 3});
        return `${basePath}/taskRecordAndSummary/taskSummaryPageListExport?projectType=9&`;
      }
    }
  },
  //病例收集
  blsj: {
    //GET /rest/crm/oss/taskRecordAndSummaryDoc/taskRecordBingliPageList
    part0: {
      list(data) {
        /**
         * OSS 线上推广 任务记录 出参：[{专区ID(channelId),csoId,乙方企业(enterpriseName)、projectId,项目名称(projectName)、任务月度(taskDt)、项目参与人(fullName)、手机号(phone)、点击数(finishSum)}]
         */
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryDoc/taskRecordBingliPageList`,
          data
        );
      },
      detailSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      taskExport(data) {
        // GET /rest/crm/oss/taskRecordAndSummaryDoc/taskRecordBingliPageListExport
        return `${basePath}/taskRecordAndSummaryDoc/taskRecordBingliPageListExport`;
      }
    },
    //  POST /rest/crm/oss/onlinepro/tasksummary
    part1: {
      list(data) {
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryDoc/taskRecordBingliSummary`,
          data
        );
      },
      taskExport(data) {
        return `${basePath}/taskRecordAndSummaryDoc/taskRecordBingliSummaryExport`;
      }
    }
  },
  //病例收集-18
  18: {
    //GET /rest/crm/oss/taskRecordAndSummaryXcxBingli/taskRecordBingliPageList
    part0: {
      list(data) {
        /**
         * OSS 线上推广 任务记录 出参：[{专区ID(channelId),csoId,乙方企业(enterpriseName)、projectId,项目名称(projectName)、任务月度(taskDt)、项目参与人(fullName)、手机号(phone)、点击数(finishSum)}]
         */
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryXcxBingli/taskRecordBingliPageList`,
          data
        );
      },
      detailSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      taskExport(data) {
        // GET /rest/crm/oss/taskRecordAndSummaryXcxBingli/taskRecordBingliPageListExport
        return `${basePath}/taskRecordAndSummaryXcxBingli/taskRecordBingliPageListExport`;
      }
    },
    //  POST /rest/crm/oss/onlinepro/tasksummary
    part1: {
      list(data) {
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryXcxBingli/taskRecordBingliSummary`,
          data
        );
      },
      taskExport(data) {
        return `${basePath}/taskRecordAndSummaryXcxBingli/taskRecordBingliSummaryExport`;
      }
    }
  },
  //医学调研
  yxdy: {
    //  POST /rest/crm/oss/onlinepro/taskRecord
    part0: {
      list(data) {
        //GET /rest/crm/oss/taskRecordAndSummaryDoc/taskRecordDiaoyanPageList
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryDoc/taskRecordDiaoyanPageList`,
          data
        );
      },

      detail(data) {
        //POST /rest/crm/oss/onlinepro/taskRecordView
        // 需要enterpriseId
        //GET /rest/crm/oss/taskRecordAndSummaryDoc/taskRecordDiaoyanDetail
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryDoc/taskRecordDiaoyanDetail`,
          data
        );
      },
      detailSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      taskExport(data) {
        //GET /rest/crm/oss/taskRecordAndSummaryDoc/taskRecordBingliPageListExport
        return `${basePath}/taskRecordAndSummaryDoc/taskRecordDiaoyanPageListExport`;
      },
      taskExport2(data) {
        //GET /rest/crm/oss/taskRecordAndSummaryDoc/taskRecordBingliPageListExport
        return `${basePath}/taskRecordAndSummaryDoc/taskRecordDiaoyanPageListExportV2New`;
      },
      taskExportData(data) {
        return request.get(
          `${basePath}/taskRecordAndSummaryDoc/taskRecordDiaoyanPageListExportShowStatus`,
          {
            params: data
          }
        );
      },
      edit(data) {
        return Vue.http.post(`${basePath}/addUpdateSigningCompanyItem`, data);
      }
    },
    part1: {
      list(data) {
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryDoc/taskRecordDiaoyanSummary`,
          data
        );
      },
      taskExport(data) {
        return `${basePath}/taskRecordAndSummaryDoc/taskRecordDiaoyanSummaryExport`;
      }
    }
  },
  //等级医院拜访
  djyybf: {
    part0: {
      list(data) {
        //1学术拜访  2 OTC巡访  3 科室会  9  等级医院拜访  10  基层医疗机构拜访
        Object.assign(data, {
          projectType: 9
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskRecordPageList`,
          data
        );
      },
      listSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/signingCompanyItemList`,
          data
        );
      },
      detailSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      taskExport(data) {
        return `${basePath}/taskRecordAndSummary/xsbfTaskRecordExport?projectType=9&`;
      }
    },
    part1: {
      list(data) {
        Object.assign(data, {
          projectType: 9
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskSummaryPageList`,
          data
        );
      },
      taskExport(data) {
        // Object.assign(data, {projectType: 3});
        return `${basePath}/taskRecordAndSummary/taskSummaryPageListExport?projectType=9&`;
      }
    }
  },
  //基层医疗机构拜访
  jcyljg: {
    part0: {
      list(data) {
        //1学术拜访  2 OTC巡访  3 科室会 9  等级医院拜访  10  基层医疗机构拜访
        Object.assign(data, {
          projectType: 10
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskRecordPageList`,
          data
        );
      },
      listSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/signingCompanyItemList`,
          data
        );
      },
      detailSum(data) {
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      taskExport(data) {
        return `${basePath}/taskRecordAndSummary/xsbfTaskRecordExport?projectType=10&`;
      }
    },
    part1: {
      list(data) {
        Object.assign(data, {
          projectType: 10
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskSummaryPageList`,
          data
        );
      },
      taskExport(data) {
        // Object.assign(data, {projectType: 3});
        return `${basePath}/taskRecordAndSummary/taskSummaryPageListExport?projectType=10&`;
      }
    }
  },
  //11特级三甲医院、12三级医院、13二级医院、14基层医疗机构、15零售药店
  11: {
    part0: {
      list(data = {}) {
        Object.assign(data, {
          projectType: 11
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummarySczr/taskRecordPageList`,
          data
        );
      },
      listSum(data = {}) {
        Object.assign(data, {
          projectType: 11
        });
        return Vue.http.post(
          `${basePath}/landingCompany/signingCompanyItemList`,
          data
        );
      },
      detailSum(data = {}) {
        Object.assign(data, {
          projectType: 11
        });
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      taskExport(data = {}) {
        Object.assign(data, {
          projectType: 11
        });
        return `${basePath}/taskRecordAndSummarySczr/taskRecordExport?projectType=${data.projectType}&`;
      }
    },
    part1: {
      list(data) {
        Object.assign(data, {
          projectType: 11
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummarySczr/taskSummaryPageList`,
          data
        );
      },
      taskExport(data = {}) {
        Object.assign(data, {
          projectType: 11
        });
        return `${basePath}/taskRecordAndSummarySczr/taskSummaryExport?projectType=${data.projectType}&`;
      }
    }
  },
  12: {
    part0: {
      list(data = {}) {
        Object.assign(data, {
          projectType: 12
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummarySczr/taskRecordPageList`,
          data
        );
      },
      listSum(data = {}) {
        Object.assign(data, {
          projectType: 12
        });
        return Vue.http.post(
          `${basePath}/landingCompany/signingCompanyItemList`,
          data
        );
      },
      detailSum(data = {}) {
        Object.assign(data, {
          projectType: 12
        });
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      taskExport(data = {}) {
        Object.assign(data, {
          projectType: 12
        });
        return `${basePath}/taskRecordAndSummarySczr/taskRecordExport?projectType=${data.projectType}&`;
      }
    },
    part1: {
      list(data) {
        Object.assign(data, {
          projectType: 12
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummarySczr/taskSummaryPageList`,
          data
        );
      },
      taskExport(data = {}) {
        Object.assign(data, {
          projectType: 12
        });
        return `${basePath}/taskRecordAndSummarySczr/taskSummaryExport?projectType=${data.projectType}&`;
      }
    }
  },
  13: {
    part0: {
      list(data = {}) {
        Object.assign(data, {
          projectType: 13
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummarySczr/taskRecordPageList`,
          data
        );
      },
      listSum(data = {}) {
        Object.assign(data, {
          projectType: 13
        });
        return Vue.http.post(
          `${basePath}/landingCompany/signingCompanyItemList`,
          data
        );
      },
      detailSum(data = {}) {
        Object.assign(data, {
          projectType: 13
        });
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      taskExport(data = {}) {
        Object.assign(data, {
          projectType: 13
        });
        return `${basePath}/taskRecordAndSummarySczr/taskRecordExport?projectType=${data.projectType}&`;
      }
    },
    part1: {
      list(data) {
        Object.assign(data, {
          projectType: 13
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummarySczr/taskSummaryPageList`,
          data
        );
      },
      taskExport(data = {}) {
        Object.assign(data, {
          projectType: 13
        });
        return `${basePath}/taskRecordAndSummarySczr/taskSummaryExport?projectType=${data.projectType}&`;
      }
    }
  },
  14: {
    part0: {
      list(data = {}) {
        Object.assign(data, {
          projectType: 14
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummarySczr/taskRecordPageList`,
          data
        );
      },
      listSum(data = {}) {
        Object.assign(data, {
          projectType: 14
        });
        return Vue.http.post(
          `${basePath}/landingCompany/signingCompanyItemList`,
          data
        );
      },
      detailSum(data = {}) {
        Object.assign(data, {
          projectType: 14
        });
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      taskExport(data = {}) {
        Object.assign(data, {
          projectType: 14
        });
        return `${basePath}/taskRecordAndSummarySczr/taskRecordExport?projectType=${data.projectType}&`;
      }
    },
    part1: {
      list(data) {
        Object.assign(data, {
          projectType: 14
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummarySczr/taskSummaryPageList`,
          data
        );
      },
      taskExport(data = {}) {
        Object.assign(data, {
          projectType: 14
        });
        return `${basePath}/taskRecordAndSummarySczr/taskSummaryExport?projectType=${data.projectType}&`;
      }
    }
  },
  15: {
    part0: {
      list(data = {}) {
        Object.assign(data, {
          projectType: 15
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummarySczr/taskRecordPageList`,
          data
        );
      },
      listSum(data = {}) {
        Object.assign(data, {
          projectType: 15
        });
        return Vue.http.post(
          `${basePath}/landingCompany/signingCompanyItemList`,
          data
        );
      },
      detailSum(data = {}) {
        Object.assign(data, {
          projectType: 15
        });
        return Vue.http.post(
          `${basePath}/landingCompany/detailSigningCompanyItem`,
          data
        );
      },
      taskExport(data = {}) {
        Object.assign(data, {
          projectType: 15
        });
        return `${basePath}/taskRecordAndSummarySczr/taskRecordExport?projectType=${data.projectType}&`;
      }
    },
    part1: {
      list(data) {
        Object.assign(data, {
          projectType: 15
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummarySczr/taskSummaryPageList`,
          data
        );
      },
      taskExport(data = {}) {
        Object.assign(data, {
          projectType: 15
        });
        return `${basePath}/taskRecordAndSummarySczr/taskSummaryExport?projectType=${data.projectType}&`;
      }
    }
  },
  16: {
    part0: {
      list(data = {}) {
        return Vue.http.post(`${basePath}/health/aiTaskList`, data);
      },
      chatRecord(data = {}) {
        return Vue.http.post(`${basePath}/health/chatRecordDetail`, data);
      },
      medicalHistory(data = {}) {
        return Vue.http.post(`${basePath}/health/casesSummaryDetail`, data);
      },
      taskExport(data = {}) {
        return `${basePath}/health/exportAITaskList`;
      }
    },
    part1: {
      list(data) {
        Object.assign(data, {
          projectType: 15
        });
        return Vue.http.post(`${basePath}/health/aiTaskSummaryList`, data);
      },
      taskExport(data = {}) {
        Object.assign(data, {
          projectType: 16
        });
        return `${basePath}/health/exportAITaskSummaryList`;
      }
    }
  },
  //数字拜访
  17: {
    part0: {
      list(data = {}) {
        //{乙方企业(enterpriseName),项目id(projectId),项目名称(projectName)、任务月度(taskDt)、项目参与人-经营者(fullName)、个体（zooidEnterpriseName）、
        // 手机号(phone)、客户名称(customerName)、医院名称/医疗机构名称(hospitalName),药店名称(pharmacyName)，客户反馈(feedbackContent),
        // 状态(auditStatus 1审核中 2审核通过 3审核未通过)，反馈途径（visitType 1微信），拜访时间（visitTime）反馈时间(feedbackDt)，医院等级（gradeName），
        // 一级科室（firstDepartmentName），二级科室（departmentName），职称（dutyName），药店职务（pharmacyPeopleDuty）省(provinceName)，市（cityName），
        // 区（districtName），地址（address）,资讯标题-数组(informationNames)，专区id-数组（channelIds），资讯id-数组（informationIds）}]
        if (openMock) {
          return easyMock([
            {
              enterpriseName: '乙方企业',
              projectId: 1,
              projectName: '项目名称',
              taskDt: '2020-01',
              fullName: '项目参与人',
              zooidEnterpriseName: '个体',
              phone: '13629736808',
              customerName: '客户名称',
              hospitalName: '医疗机构名称',
              pharmacyName: '药店名称',
              feedbackContent: '客户反馈',
              auditStatus: 1, //(审核中 2审核通过 3审核未通过)
              visitType: 1,
              visitTime: '2020-09',
              feedbackDt: '2018-12',
              gradeName: '医院等级',
              firstDepartmentName: '一级科室',
              departmentName: '二级科室',
              dutyName: '职称',
              pharmacyPeopleDuty: '药店职务',
              provinceName: '省',
              cityName: '市',
              districtName: '区',
              address: '地址',
              informationNames: ['资讯标题-数组'],
              channelIds: ['专区id-数组'],
              informationIds: ['资讯id-数组']
            }
          ]);
        }
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryNum/taskRecordPageList`,
          data
        );
      },
      //审核不通过 todo
      chatRecord(data = {}) {
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryNum/taskNotPass`,
          data
        );
      },
      medicalHistory(data = {}) {
        return Vue.http.post(`${basePath}/health/casesSummaryDetail`, data);
      },
      taskExport(data = {}) {
        return `${basePath}/taskRecordAndSummaryNum/taskRecordPageListExport`;
      }
    },
    part1: {
      list(data) {
        //       {乙方企业(enterpriseName)、projectId,项目名称(projectName)、任务月度(taskDt)、
        //       项目参与人(fullName)、手机号(phone)、
        //       场景类型(assistantAlliance)、计划任务量(taskSum),实际完成量(finishSum),未完成量(notFinish),
        //       通过量(passSum),未通过量(notPassSum),任务完成率(finishRate)}
        if (openMock) {
          return easyMock([
            {
              enterpriseName: '乙方企业',
              projectId: 1,
              projectName: '项目名称',
              taskDt: '2020-01',
              fullName: '项目参与人',
              phone: '13629736808',
              assistantAlliance: '场景类型',
              taskSum: '12',
              finishSum: '22',
              notFinish: '12',
              passSum: '212',
              notPassSum: '12',
              finishRate: '12'
            }
          ]);
        }

        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryNum/taskSummaryPageList`,
          data
        );
      },

      taskExport(data = {}) {
        Object.assign(data, {
          projectType: 17
        });
        return `${basePath}/taskRecordAndSummaryNum/taskSummaryPageListExport`;
      }
    }
  },
  19: {
    part0: {
      list(data = {}) {
        if (openMock) {
          return easyMock([
            {
              urlcreateDt: '2020-07-0318:39:37;2020-07-0318:39:49',
              fullName: '尹滨',
              jyz: '尹滨',
              taskDt: '2020-07',
              audit_status: null,
              FolderName: 'aaa的任务名称1',
              urlNames: 'aaa;bbb',
              finishSumTaskPrice: null,
              urls: 'http://www.baidu.com;http://www.tianya.cn',
              gtmc: null,
              phone: '15801313717',
              signing_status: null,
              assistantAlliance: '助手联盟',
              id: 1,
              projectName: '工具等级医院拜访20200630152743',
              enterpriseName: '天津九如医疗科技有限公司',
              uploadNum: 4
            }
          ]);
        }
        let query = Object.assign(data || {}, { projectType: 19 });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskRecordPageList`,
          query
        );
      },
      //审核不通过 todo
      chatRecord(data = {}) {
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryNum/taskNotPass`,
          data
        );
      },
      medicalHistory(data = {}) {
        return Vue.http.post(`${basePath}/health/casesSummaryDetail`, data);
      },
      taskExport(data = {}) {
        return `${basePath}/taskRecordAndSummary/saasAgreementServiceTaskRecordExport`;
      }
    },
    part1: {
      list(data) {
        //       {乙方企业(enterpriseName)、projectId,项目名称(projectName)、任务月度(taskDt)、
        //       项目参与人(fullName)、手机号(phone)、
        //       场景类型(assistantAlliance)、计划任务量(taskSum),实际完成量(finishSum),未完成量(notFinish),
        //       通过量(passSum),未通过量(notPassSum),任务完成率(finishRate)}
        if (openMock) {
          return easyMock([
            {
              enterpriseName: '乙方企业',
              projectId: 1,
              projectName: '项目名称',
              taskDt: '2020-01',
              fullName: '项目参与人',
              phone: '13629736808',
              assistantAlliance: '场景类型',
              taskSum: '12',
              finishSum: '22',
              notFinish: '12',
              passSum: '212',
              notPassSum: '12',
              finishRate: '12'
            }
          ]);
        }
        Object.assign(data, {
          projectType: 19
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskSummaryPageList`,
          data
        );
      },

      taskExport(data = {}) {
        return `${basePath}/taskRecordAndSummary/taskSummaryPageListExport`;
      }
    }
  },
  20: {
    part0: {
      list(data = {}) {
        if (openMock) {
          return easyMock([
            {
              urlcreateDt: '2020-07-0318:39:37;2020-07-0318:39:49',
              fullName: '尹滨',
              jyz: '尹滨',
              taskDt: '2020-07',
              audit_status: null,
              FolderName: 'aaa的任务名称1',
              urlNames: 'aaa;bbb',
              finishSumTaskPrice: null,
              urls: 'http://www.baidu.com;http://www.tianya.cn',
              gtmc: null,
              phone: '15801313717',
              signing_status: null,
              assistantAlliance: '助手联盟',
              id: 1,
              projectName: '工具等级医院拜访20200630152743',
              enterpriseName: '天津九如医疗科技有限公司',
              uploadNum: 4
            }
          ]);
        }
        let query = Object.assign(data || {}, { projectType: 20 });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskRecordMakeSceneList`,
          query
        );
      },
      //审核不通过 todo
      chatRecord(data = {}) {
        return Vue.http.post(
          `${basePath}/taskRecordAndSummaryNum/taskNotPass`,
          data
        );
      },
      detail(data = {}) {
        Object.assign(data, {
          projectType: 20
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/makeSceneDetail`,
          data
        );
      },
      medicalHistory(data = {}) {
        return Vue.http.post(`${basePath}/health/casesSummaryDetail`, data);
      },
      taskExport(data = {}) {
        return `${basePath}/taskRecordAndSummary/makeSceneDetailExport`;
      }
    },
    part1: {
      list(data) {
        //       {乙方企业(enterpriseName)、projectId,项目名称(projectName)、任务月度(taskDt)、
        //       项目参与人(fullName)、手机号(phone)、
        //       场景类型(assistantAlliance)、计划任务量(taskSum),实际完成量(finishSum),未完成量(notFinish),
        //       通过量(passSum),未通过量(notPassSum),任务完成率(finishRate)}
        if (openMock) {
          return easyMock([
            {
              enterpriseName: '乙方企业',
              projectId: 1,
              projectName: '项目名称',
              taskDt: '2020-01',
              fullName: '项目参与人',
              phone: '13629736808',
              assistantAlliance: '场景类型',
              taskSum: '12',
              finishSum: '22',
              notFinish: '12',
              passSum: '212',
              notPassSum: '12',
              finishRate: '12'
            }
          ]);
        }
        Object.assign(data, {
          projectType: 20
        });
        return Vue.http.post(
          `${basePath}/taskRecordAndSummary/taskSummaryMakeSceneList`,
          data
        );
      },
      taskExport(data = {}) {
        return `${basePath}/taskRecordAndSummary/taskSummaryMakeSceneExport`;
      }
    }
  }
};
export const receivReport = {
  // 验收报告审核报告前置判断
  checkAcceptanceAndAudit: data => {
    return Vue.http.post(`${baseUrl}/dataPack/checkAcceptanceAndAudit`, data, {
      // yapi: '24451'
    });
  }
};
export const biBase = {
  saveBiInfo: data => {
    return Vue.http.post(`${baseUrl}/bi/biVisit/saveBiInfo`, data, {
      // yapi: '657'
    });
  },
  getBiInfoUpdateStatus: data => {
    return Vue.http.post(`${baseUrl}/bi/biVisit/getBiInfoUpdateStatus`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  projectCurrent: data => {
    return Vue.http.post(`${baseUrl}/dataPack/projectCurrent`, data);
  },
  saveDownLoadTaskByBiInfoId: data => {
    return Vue.http.post(
      `${baseUrl}/bi/makeScene/saveDownLoadTaskByBiInfoId`,
      data
    );
  },
  getFenpeiIdList: data => {
    return Vue.http.post(`${baseUrl}/bi/biVisit/getFenpeiIdList`, data);
  },
  getFenpeiIdListV2: data => {
    return Vue.http.post(`${baseUrl}/v2/bi/biVisit/getFenpeiIdList`, data);
  },
  saveTSaasBiCustomReport: data => {
    return Vue.http.post(
      `${baseUrl}/bi/tSaasBiCustomReport/saveTSaasBiCustomReport`,
      data
    );
  },
  // ???: 重复注册接口
  saveTSaasBiCustomReportV2: data => {
    return Vue.http.post(
      `${baseUrl}/v2/bi/biVisit/saveTSaasBiCustomReport`,
      data
    );
  },
  getCustomReportStartTime: data => {
    return Vue.http.post(
      `${baseUrl}/bi/tSaasBiCustomReport/getCustomReportStartTime`,
      data
    );
  },
  listTSaasBiCustomReport: async data => {
    const getFileName = fileUrl => {
      try {
        const name = fileUrl.match(/(?:.+\/)(.+)/)[1];
        return decodeURIComponent(name.split('.')[0]);
      } catch (error) {
        return fileUrl;
      }
    };
    // 改造接口
    const resp = await Vue.http.post(
      `${baseUrl}/bi/tSaasBiCustomReport/listTSaasBiCustomReport`,
      data
    );
    const {
      pdata: { list }
    } = resp;
    list.forEach(item => {
      // 所有下载情况都使用taskRecordUrls字段，length为1点击下载直接下载，为2点击下载出现弹层列表
      if (!item.taskRecordUrls) {
        const oldUrl = item.downloadUrl || item.taskRecordUrl;
        if (oldUrl) {
          item.taskRecordUrls = [
            {
              downloadName: getFileName(oldUrl),
              downloadUrl: oldUrl,
              fileSize: item.fileSize || '-',
              urlStatus: 1 // 整理的数据设置为1，方便统一处理。只有自定义的链接有失效。1有效\2失效
            }
          ];
        } else {
          item.taskRecordUrls = [];
        }
      }
    });
    return resp;
  },
  listTSaasBiCustomReportV2: async data => {
    const getFileName = fileUrl => {
      try {
        const name = fileUrl.match(/(?:.+\/)(.+)/)[1];
        return decodeURIComponent(name.split('.')[0]);
      } catch (error) {
        return fileUrl;
      }
    };
    // 改造接口
    const resp = await Vue.http.post(
      `${baseUrl}/v2/bi/biVisit/listTSaasBiCustomReport`,
      data
    );
    const {
      pdata: { list }
    } = resp;
    list.forEach(item => {
      // 所有下载情况都使用taskRecordUrls字段，length为1点击下载直接下载，为2点击下载出现弹层列表
      if (!item.taskRecordUrls) {
        const oldUrl = item.downloadUrl || item.taskRecordUrl;
        if (oldUrl) {
          item.taskRecordUrls = [
            {
              downloadName: getFileName(oldUrl),
              downloadUrl: oldUrl,
              fileSize: item.fileSize || '-',
              urlStatus: 1 // 整理的数据设置为1，方便统一处理。只有自定义的链接有失效。1有效\2失效
            }
          ];
        } else {
          item.taskRecordUrls = [];
        }
      }
    });
    return resp;
  }
};

export const makeSceneBi = {
  templateList: data => {
    return Vue.http.post(`${baseUrl}/bi/teamplate/listTemplate`, data, {
      // yapi: '657'
    });
  },
  baseInfo: data => {
    return Vue.http.post(`${baseUrl}/bi/makeScene/base/info`, data, {
      // yapi: '657'
    });
  },
  fixedInfo: data => {
    return Vue.http.post(`${baseUrl}/bi/makeScene/fixed/info`, data, {
      // yapi: '657'
    });
  },
  topicInfo: data => {
    return Vue.http.post(`${baseUrl}/bi/makeScene/topic/info`, data, {
      // yapi: '657'
    });
  },
  groupInfo: data => {
    return Vue.http.post(`${baseUrl}/bi/makeScene/group/info`, data, {
      // yapi: '657'
    });
  },
  // 获取是否含有照片题
  getImageQuestionCount: data => {
    return Vue.http.post(`${baseUrl}/pw/getImageQuestionCount`, data, {
      // yapi: '657'
    });
  },
  // 当期BI-保持选择的图片
  saveBiPicList: data => {
    return Vue.http.post(`${baseUrl}/pw/saveBiPicList`, data, {
      // yapi: '657'
    });
  },
  // 当期BI-任务记录图片列表
  getTaskPicList: data => {
    return Vue.http.post(`${baseUrl}/pw/getTaskPicList`, data, {
      // yapi: '657'
    });
  },
  // 累计BI、自定义数据报告获取随机50张图片
  getImageList: data => {
    return Vue.http.post(`${baseUrl}/pw/getImageList`, data, {
      // yapi: '657'
    });
  },
  saveInfo: data => {
    return Vue.http.post(`${baseUrl}/bi/makeScene/info/save`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  download: `${baseUrl}/bi/makeScene/download`
};

export const hgtgBi = {
  baseInfo: data => {
    return Vue.http.post(`${baseUrl}/bi/hgtg/getHgtgBaseInfo`, data, {
      // yapi: '657'
    });
  },
  fixedInfo: data => {
    return Vue.http.post(`${baseUrl}/bi/hgtg/getStyleConfigureFixed`, data, {
      // yapi: '657'
    });
  },
  topicInfo: data => {
    return Vue.http.post(`${baseUrl}/bi/hgtg/getStyleConfigureHgtg`, data, {
      // yapi: '657'
    });
  },
  groupInfo: data => {
    return Vue.http.post(`${baseUrl}/bi/hgtg/ListsingleContent`, data, {
      // yapi: '657'
    });
  },
  saveInfo: data => {
    return Vue.http.post(`${baseUrl}/bi/hgtg/updateHgtgBaseInfo`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  }
};

export const digitalQuestionnaireBi = {
  baseInfo: data => {
    return Vue.http.post(`${baseUrl}/bi/nq/getNumQuestBaseInfo`, data, {
      // yapi: '657'
    });
  },
  fixedInfo: data => {
    return Vue.http.post(
      `${baseUrl}/bi/nq/getNumQuestStyleConfigureFixed`,
      data,
      {
        // yapi: '657'
      }
    );
  },
  topicInfo: data => {
    return Vue.http.post(`${baseUrl}/bi/nq/getNumQuestStyleConfigure`, data, {
      // yapi: '657'
    });
  },
  groupInfo: data => {
    return Vue.http.get(
      `${baseUrl}/bi/nq/getNumQuestBIPromoteCatalogueDetail`,
      {
        params: data
        // yapi: '657'
      }
    );
  },
  saveInfo: data => {
    return Vue.http.post(`${baseUrl}/bi/nq/updateNumQuestBiInfo`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  }
};

export const taxPayment = {
  // 服务商下拉列表
  selectBox: data => {
    return Vue.http.post(`${baseUrl}/taxPayment/selectBox`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 完税证明列表
  list: data => {
    return Vue.http.post(`${baseUrl}/taxPayment/list`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 完税证明 - 通过ID查看
  detail: data => {
    return Vue.http.post(`${baseUrl}/taxPayment/id`, data);
  },
  // 完税证明 - 通过ID下载
  downloadAnnex: `${baseUrl}/taxPayment/downloadAnnex`,

  // 完税证明 - 通过ID下载 - ajax方式
  downloadAnnexAjax: data => {
    return Vue.http.post(`${baseUrl}/taxPayment/downloadAnnex`, data);
  },
  // 个体自然人-完税证明列表
  personAlityList: data => {
    return Vue.http.post(`${baseUrl}/taxPayment/hyxk/list`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 个体自然人-完税证明详情
  proofAttById: data => {
    return Vue.http.post(`${baseUrl}/taxPayment/hyxk/get`, data);
  },
  // 个体自然人-完税证明列表下载
  personAlityListDownLoad: data => {
    return Vue.http.post(`${baseUrl}/taxPayment/hyxk/download`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  }
};

export const invoice = {
  // 发票列表 - 销售方下拉列表
  listSelectEnterprise: data => {
    return Vue.http.post(`${baseUrl}/invoice/listSelectEnterprise`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 发票列表
  list: data => {
    return Vue.http.post(`${baseUrl}/invoice/listInvoice`, data);
  },
  // 开票信息
  getInvoiceBaseInfo: data => {
    return Vue.http.post(`${baseUrl}/invoice/getInvoiceBaseInfo`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 更新开票信息
  invoiceBaseInfo: data => {
    return Vue.http.post(`${baseUrl}/invoice/invoiceBaseInfo`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 申请开票 - 基础信息获取
  applyInvoice: data => {
    return Vue.http.post(`${baseUrl}/invoice/applyInvoice`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 申请开票 - 获取服务商
  getInvoiceCate: data => {
    return Vue.http.post(`${baseUrl}/invoice/getInvoiceCate`, data);
  },
  // 申请开票 - 保存并提交
  saveInvoiceApply: data => {
    return Vue.http.post(`${baseUrl}/invoice/saveInvoiceApply`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 申请开票 - 审核
  auditInvoice: data => {
    return Vue.http.post(`${baseUrl}/invoice/auditInvoice`, data, {
      notUseQs: true,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    });
  },
  // 发票详情
  detail: data => {
    return Vue.http.post(`${baseUrl}/invoice/id`, data);
  }
};

// 获取下一个项目信息
export const nextProject = data => {
  return Vue.http.post(`${baseUrl}/project/nextProject`, data);
};

// 批量确认项目
export const batchConfirmProject = data => {
  return Vue.http.post(`${baseUrl}/industryProject/batchConfirmProject`, data);
};

// 是否显示审核人姓名
export const projectCsoAuditShow = data => {
  return Vue.http.post(`${baseUrl}/industryProject/projectCsoAuditShow`, data);
};
/****************************************************数字问卷****************************************************************/
export const digitalQuestionnaire = {
  // 数字问卷-任务记录列表
  taskRecordList(data) {
    return Vue.http.post(`${baseUrl}/taskRecord/taskRecordList`, data);
  },
  // 数字问卷-任务记录详情
  taskRecordDetail(data) {
    return Vue.http.post(`${baseUrl}/taskRecord/info`, data);
  }
};

// 当期数据包图片版本-展示隐藏图片版本
export const confirm = {
  showTheHiddenImageVersion(data) {
    return Vue.http.post(`${baseUrl}/confirm/showTheHiddenImageVersion`, data);
  }
};
/****************************************************版本控制****************************************************************/
export const clientVersion = {
  getVersion: data => Vue.http.post(`${baseUrl}/clientVersion/getVersion`, data)
};
// 是否提示上线
export const tipsMessage = data =>
  Vue.http.post(`${baseUrl}/message/tipsMessage`, data);

/****************************************************新版bi****************************************************************/
export const BIv2 = {
  // getBiModuleByBiId: data => Vue.http.post(`${baseUrl}/v2/bi/biVisit/getBiModuleByBiId`, data)
  saveBiInfo(data) {
    return Vue.http.post(
      `${baseUrl}/v2/bi/biVisit/saveTSaasBiCustomReport`,
      data
    );
  },
  getBiModuleByBiId(data) {
    return Vue.http.post(`${baseUrl}/v2/bi/biVisit/getBiModuleByBiId`, data);
  },
  updateBiModuleById(data) {
    return Vue.http.post(`${baseUrl}/v2/bi/biVisit/updateBiModuleById`, data);
  }
};
//业务说明 http://yapi.jimijiayuan.cn/project/645/interface/api/27656
export const bizDesc = data => {
  return Vue.http.post(`${baseUrl}/project/bizDesc`, data);
};
/****************************************************招商管理****************************************************************/
export const zsManageIsHidden = () =>
  Vue.http.get(`${baseUrl}/zs/config/zsStatus`); //查询招商状态（权限）

/****************************************************是否隐藏提交材料及相关子菜单****************************************************************/
export const biTmplIsHidden = () =>
  Vue.http.get(`${baseUrl}/certificate/isHidden`); //是否隐藏提交材料及相关子菜单
